namespace TabAurous.Production {
    export namespace WIPTransactionService {
        export const baseUrl = 'Production/WIPTransaction';

        export declare function Create(request: Serenity.SaveRequest<WIPTransactionRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<WIPTransactionRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<WIPTransactionRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<WIPTransactionRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function MFGBOMList(request: TransactionRequest, onSuccess?: (response: Serenity.ListResponse<WIPTransactionRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "Production/WIPTransaction/Create",
            Update = "Production/WIPTransaction/Update",
            Delete = "Production/WIPTransaction/Delete",
            Retrieve = "Production/WIPTransaction/Retrieve",
            List = "Production/WIPTransaction/List",
            MFGBOMList = "Production/WIPTransaction/MFGBOMList"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List', 
            'MFGBOMList'
        ].forEach(x => {
            (<any>WIPTransactionService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
